export default __webpack_public_path__ + "static/media/icon-twitter.6be81373.svg";